import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Animal Cracker Parade",
  date: new Date(2024, 10, 17),
  img: "/img/animal-cracker.jpeg",
  tracks: [
    {
      title: "Call Of The Wild",
      src: "/songs/2024-11-17/call_of_the_wild.mp3",
      duration: 498.984,
    },
    {
      title: "Evening Stroll",
      src: "/songs/2024-11-17/evening_stroll.mp3",
      duration: 383.472,
    },
    {
      title: "Lightning In The Dark",
      src: "/songs/2024-11-17/lightning_in_the_dark.mp3",
      duration: 1074.936,
    },
    {
      title: "In The Blink Of An Eye",
      src: "/songs/2024-11-17/in_the_blink_of_an_eye.mp3",
      duration: 541.488,
    },
    {
      title: "Determined Gumshoe",
      src: "/songs/2024-11-17/determined_gumshoe.mp3",
      duration: 905.376,
    },
    {
      title: "What I'm Lookin' For",
      src: "/songs/2024-11-17/what_im_lookin_for.mp3",
      duration: 732.384,
    },
    {
      title: "Sixty Dollar Ounce",
      src: "/songs/2024-11-17/sixty_dollar_ounce.mp3",
      duration: 424.68,
    },
    {
      title: "The Truth Is Coming Our Way",
      src: "/songs/2024-11-17/the_truth_is_coming.mp3",
      duration: 418.176,
    },
    {
      title: "Acid Rain Drops",
      src: "/songs/2024-11-17/acid_rain_drops.mp3",
      duration: 1246.44,
    },
  ],
};
export default album;
